// extracted by mini-css-extract-plugin
export default {"clModal":"login_clModal__hry4Y","clBoxLogout":"login_clBoxLogout__2gJko"};